export const DELIMITER = '-'

/**
 * Format is ${name-delimited-with-hypens}-${slug}.
 */
export function getSlugFromPrettyUrl(prettyUrl = '') {
  const slug = prettyUrl.split(DELIMITER).pop()

  return (slug || '').toLowerCase()
}
